<template>
  <div id="app">
<!--    <p id="screen-size">{{windowWidth}}x{{windowHeight}}</p>-->
    <app-header id="app-header"/>
    <div id="gray-area">
      <div id="main-container">
        <map-header @showModal="shouldShowModal = true"/>
        <google-map/>
        <div id="biz-list-container">
          <biz-list id="biz-list"/>
          <biz-info id="biz-info"/>
        </div>
      </div>
    </div>
    <app-footer id="app-footer" @showPrivacyPolicy="shouldShowPrivacyPolicy = true"/>
    <modal id="modal" v-show="shouldShowModal" @hide="shouldShowModal = false" @showThankYou="shouldShowThankYou = true"/>
    <thank-you id="thank-you" v-show="shouldShowThankYou" @hide="shouldShowThankYou = false"/>
    <privacy-policy id="privacy-policy" v-show="shouldShowPrivacyPolicy" @hide="shouldShowPrivacyPolicy = false"/>
  </div>
</template>
<script>
  import AppHeader from './components/AppHeader.vue'
  import GoogleMap from './components/GoogleMap.vue'
  import MapHeader from './components/MapHeader.vue'
  import BizList from './components/BizList.vue'
  import BizInfo from "./components/BizInfo";
  import AppFooter from './components/AppFooter.vue'
  import Modal from './components/Modal.vue'
  import ThankYou from './components/ThankYou.vue'
  import PrivacyPolicy from './components/PrivacyPolicy.vue'

  export default {
    components: {
      AppHeader,
      MapHeader,
      GoogleMap,
      BizList,
      BizInfo,
      AppFooter,
      Modal,
      ThankYou,
      PrivacyPolicy
    },
    data() {
      return {
        windowWidth: 0,
        windowHeight: 0,
        shouldShowModal: false,
        shouldShowThankYou: false,
        shouldShowPrivacyPolicy: false
      }
    },
    mounted() {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
        this.windowHeight = window.innerHeight
      })
    }
  }
</script>

<style>
  * {
    -webkit-overflow-scrolling: touch;
  }
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #232A2E;
  }
  #screen-size {
    position: fixed;
    top: 0;
    left: 0;
    color: black;
  }
  #gray-area {
    background: #F4F4F4;
    padding-top: 68px;
    padding-bottom: 68px;
  }
  #main-container {
    margin: 0 auto;
    width: 85%;
    background-color: white;
  }
  #modal, #thank-you, #privacy-policy {
    /*display: none;*/
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.58);
    z-index: 2;
    overflow: hidden;
    overflow-y: scroll;
    display: inherit !important;
    -webkit-transition: all 0.2s ease;
    -moz-transition: all 0.2s ease;
    -o-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }
  #thank-you {
    transition-delay: 0.2s;
  }
  #modal[style*="display: none;"], #thank-you[style*="display: none;"], #privacy-policy[style*="display: none;"] {
    opacity: 0;
    transform: scale(1.1);
    pointer-events: none;
    user-select: none;
  }

  /*DESKTOPS*/
  @media only screen and (min-width: 769px) {
    #biz-list-container {
      padding-top: 15px;
      padding-bottom: 15px;
      height: 400px;
      background: white;
    }
    #biz-list {
      float: left;
      width: 30%;
      height: 100%;
      max-width: 360px;
    }
    #biz-info {
      height: 100%;
      width: 70%;
      margin-left: 30%;
      padding-left: 15px;
    }
  }

  /*LARGE DESKTOPS*/
  @media only screen and (min-width: 1440px) {
    #main-container {
      margin: 0 112px;
      width: auto;
    }
    #biz-info {
      margin-left: 360px;
      margin-right: 0;
      width: auto;
    }
  }

  /*MOBILE*/
  @media only screen and (max-width: 768px) {
    #gray-area {
      padding-top: 32px;
      padding-bottom: 32px;
    }
    #main-container {
      width: 93%;
    }
    #biz-list-container {
      padding-top: 15px;
      padding-bottom: 15px;
      background: white;
    }
    #biz-list {
      height: 110px;
    }
    #biz-info {
      height: 100%;
      margin-top: 10px;
      padding-left: 10px;
    }
  }
</style>
